import router from '@/router';
/**
 * 주어진 라우트 이름과 쿼리 파라미터를 사용하여 URL 객체를 생성한다.
 * @param routeName 라우트 이름
 * @param query 쿼리 파라미터
 * @returns URL 객체
 */
export const getRouterUrl = ({ routeName, params, query, }) => {
    const path = router.resolve({
        name: routeName,
        params,
    }).href;
    const url = new URL(path, window.location.origin);
    Object.entries(query ?? {}).forEach(([key, value,]) => {
        url.searchParams.append(key, value);
    });
    return url;
};
/**
 * 객체를 쿼리 스트링으로 변환
 * 예시) { width: 1024, height: 768 } -> 'width=1024,height=768'
 * @param obj
 * @returns
 */
export const objectToQueryString = (obj) => Object.entries(obj)
    .map(([key, value,]) => `${key}=${value}`)
    .join(',');
